$(document).ready(function(){
  // Post-login redirect: send the customer back to where they were.
  // Domain-relative so the same code works on ca. and us.throatthreads.com.
  var checkout_url = function(){
      var location_href = location.href;
      if(window.location.pathname == "/account/login"){
        var urlParams = new URLSearchParams(window.location.search);
        location_href = urlParams.get('checkout_url') || '/';
      }
      $('.login-screen').find('#customer form').find('[name="checkout_url"]').val(location_href);
  }

  if($('.login-screen').is(':visible')){
    checkout_url();
  }

  // Re-apply briefly in case the login form re-renders, then stop (was: ran forever).
  var checkoutUrlTries = 0;
  var checkoutUrlInterval = setInterval(function(){
    checkout_url();
    checkoutUrlTries++;
    if(checkoutUrlTries >= 100){ clearInterval(checkoutUrlInterval); }
  }, 100);


  // ATC
$('#atc-btn').on('click', function(e){
  e.preventDefault();

  var $btn = $(this);
  // Guard against double-clicks: one submission at a time.
  if ($btn.hasClass('atc-busy')) { return; }
  $btn.addClass('atc-busy disabled').css({'pointer-events':'none','opacity':'0.6'});
  var atcDone = function(){
    $btn.removeClass('atc-busy disabled').css({'pointer-events':'auto','opacity':'1'});
  };

  var form = $(this).closest('form');
  var vid = [];
  var data = []; // fresh per click — never accumulate across clicks

  $('.v-table-col-main.selected').each(function(){
    //var inseam = $('.input-row').find('.in-seam');
    var inseam = $('.input-row').find('.in-seam, .inseam'); // Select elements with either class
    var th = $(this);
    var val;

    if (inseam.length === 0) {
      val = th.find('.data-wrap').attr('data-variant');
    } else {
      val = th.find('.data-wrap.inseam').attr('data-variant');
    }

    vid.push(val);
  });

  for (var i of vid.reverse()) {
    var items = {};
    items.id = i;
    items.quantity = Number($('#quantity-' + i).val()) || 0;
    data.push(items);
  }

  if (!data.length) { atcDone(); return; }

  $.getJSON('/cart.js', function(cart) {
    const cartItems = cart.items;
    const updateData = [];
    const addData = [];



    data.forEach(item => {
      const cartItem = cartItems.find(ci => ci.variant_id === Number(item.id));
      console.log(cartItem);
      if (cartItem) {
        updateData.push({
          id: cartItem.key, // full line item key (variant_id:hash)
          quantity: item.quantity // 0 is intentional: removes the line
        });
      } else if (item.quantity > 0) {
        addData.push(item); // new item to add — never send qty 0 to /cart/add.js
      }
    });

    const updatesObj = Object.fromEntries(updateData.map(u => [u.id, u.quantity]));

    // Nothing to change (e.g. only zero-qty cells that were never in the cart):
    // don't show a false success message.
    if (!Object.keys(updatesObj).length && !addData.length) {
      $('.cart-message').html('No quantities selected — nothing was added.');
      $('.cart-message').fadeIn().delay(4000).fadeOut();
      atcDone();
      return;
    }

    let promise = Promise.resolve();

    if (Object.keys(updatesObj).length) {
      promise = promise.then(() => {
        return $.post('/cart/update.js', {
          updates: updatesObj
        });
      });
    }

    if (addData.length) {
      promise = promise.then(() => {
        return $.post('/cart/add.js', { items: addData });
      });
    }

    promise.then(() => {
      $('.cart-message').html('Your item(s) have been added to the cart successfully. <a href="/cart">View Cart</a>');
      $('.cart-message').fadeIn().delay(5000).fadeOut();

      // ✅ Update cart count
      $.getJSON('/cart.js', function(cart) {
        if ($('.cart-link__count').length) {
          $('.cart-link__count').html(cart.item_count);
        } else {
          $('.cart-link__icon').append('<span class="cart-link__count">' + cart.item_count + '</span>');
        }
      });

      // ✅ Do NOT reset quantities
      $('.v-table-col-main.selected').removeClass('selected');

      atcDone();
    }).catch(xhr => {
      let errorMessage = 'Something went wrong. Please try again.';
      try {
        const errorData = JSON.parse(xhr.responseText);
        if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        console.warn('Failed to parse error response:', e);
      }

      $('.cart-message').html('<span class="error">' + errorMessage + '</span>');
      $('.cart-message').fadeIn().delay(5000).fadeOut();

      atcDone();
    });
  }).fail(function(){
    atcDone();
  });
});
  // qty adjustments
  $('.qtybox .btnqty').on('click', function () {
  var $qtyBox = $(this).parent('.qtybox');
  var $input = $qtyBox.find('.quantity-input');
  var $dataWrap = $(this).closest('.data-wrap');
  var $invQty = $dataWrap.find('.inv-qty');
  var $plusBtn = $qtyBox.find('.qtyplus');

  var qty = parseInt($input.val()) || 0;
  var inventory = parseInt($invQty.text()) || 0;
  var max = parseInt($input.attr('max')) || inventory;

  if ($(this).hasClass('qtyplus')) {
    if (inventory > 0 && qty < max) {
      qty++;
      inventory--;
    }
  } else {
    if (qty > 0) {
      qty--;
      inventory++;
    }
  }

  $input.val(qty);
  $invQty.text(inventory);

  // Toggle selected class based on quantity
  //if (qty !== 0) {
    $(this).closest('.v-table-col-main').addClass('selected');
  //} else {
    //$(this).closest('.v-table-col-main').removeClass('selected');
  //}

  // Disable plus button if inventory is 0
  if (inventory <= 0) {
    $plusBtn.addClass('disabled').css('pointer-events', 'none').css('opacity', '0.5');
  } else {
    $plusBtn.removeClass('disabled').css('pointer-events', 'auto').css('opacity', '1');
  }
});
  
  $('.v-table-main .quantity-selector').on('input', function(e){
    e.preventDefault();
    var q = $(this).val();
    if(q != 0){
      $(this).closest('.v-table-col-main').addClass('selected');
    }
    else{
      $(this).closest('.v-table-col-main').removeClass('selected');
    }
  });
  

  if(localStorage.getItem('hidePrice') == '1'){
    $('body').addClass('no-price');	
    if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
    }
    else{
      $('.price-cont').show();
    }
    $('.toggle-price i').attr('class','bi bi-eye-slash');
  }
  else{
    $('body').removeClass('no-price');
       if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
    $('.toggle-price i').attr('class','bi bi-eye');
  }
  
  // price button in header
  $('.toggle-price').on('click', function(e){
    e.preventDefault();
    var th = $(this);
    if(localStorage.getItem('hidePrice') == '1'){
      if(document.location.href.indexOf('NoPrice') > -1) { // found
        var url = document.location.href.split("NoPrice")[0];
        document.location = url;
      }
      else{
      	// do nothing
      }
      localStorage.setItem('hidePrice', '0');
      $('body').removeClass('no-price');
         if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
      $('.toggle-price i').attr('class','bi bi-eye');
    }
    else{
      if(document.location.href.indexOf('NoPrice') > -1) { // found
        // do nothing
      }
      else{
        if(document.location.href.indexOf('?') > -1) {
          var url = document.location.href+"&NoPrice";
          document.location = url;
        }
        else{
          var url = document.location.href+"?NoPrice";
          document.location = url;
        } 
      }
      localStorage.setItem('hidePrice', '1');
      $('body').addClass('no-price');
         if ($("body").hasClass("no-price")) {
      $('.price-cont').hide();
      }
      else{
          $('.price-cont').show();
      }
      $('.toggle-price i').attr('class','bi bi-eye-slash');
    }
  });
  // stacked images
  if($('body').hasClass('template-suffix-marketing')){
    $(".gallery a.open-gallery").fancybox({
      arrows: "true",
      infobar: "true",
      smallBtn: "auto",
      buttons: [
        "zoom",
        //"share",
        "slideShow",
        //"fullScreen",
        //"download",
        "thumbs",
        "close"
      ],
    });
  }
  // mobile footer
  var media = window.matchMedia("(max-width: 767px)");
  if (media.matches) {
    $('#shopify-section-footer ul.section-footer__menu-block__menu > li > a').on('click', function(e){
      e.preventDefault();
      $(this).toggleClass('open');
      //$(this).next('ul.child').slideToggle();
      $(this).next('ul.child').toggleClass('open');
      
    });
  }
  
  var parent = $('.navigation__link.active').attr('data-parent');
  $('.navigation__tier-1 .navigation__link[data-main="'+parent+'"]').addClass('active');
  $('.v-table-main .quantity-selector').on('input', function(){
    var max = Number($(this).attr('max'));
    var v = Number($(this).val());
    console.log(v,max)
    if(v > max){
      $(this).val(max);
    }
  });
  // cart page variant table
  var discTotal = 0;
  var regTotal = 0;
  $('.cart-item').each(function(){
    var handle = $(this).attr('data-handle');
    if($('.cart-item[data-handle="'+handle+'"]').length >= 1){
      $('.cart-item[data-handle="'+handle+'"]:not(:first)').hide();
      $('.cart-item[data-handle="'+handle+'"]').find('#cart-variant-table input').each(function(){
        if($(this).val() == ''){
        	$(this).val(0);
        }
      })
      return;
    }
    
  });
  $('.cart-item:visible').each(function(){
    discTotal = discTotal + Number($(this).find('.discounted-price').attr('data-dp'));
    regTotal = regTotal + Number($(this).find('.regular-price').attr('data-rp'));
  });
  $('.discounted-subtotal').html(Shopify.formatMoney(discTotal, $('body').attr('data-mf')));
  $('.regular-subtotal').html(Shopify.formatMoney(regTotal, $('body').attr('data-mf')));
  console.log(regTotal, discTotal);
  
  $('#cart-variant-table .btnqty').off('click').on('click', function(e) {
    e.preventDefault();
    $('#cart-variant-table .btnqty').addClass('disabled')
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    var max = parseInt($(this).parent('.qtybox').find('.quantity-input').attr('max'));
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty >= 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?0:qty;
    if(qty > max){
      $(this).parent('.qtybox').find('.quantity-input').val(max);
      $('#cart-variant-table .btnqty').removeClass('disabled');
    }
    else{
      $(this).parent('.qtybox').find('.quantity-input').val(qty);
      var currentVariant = $(this).parent('.qtybox').find('input').attr('data-variant');
      jQuery.post('/cart/update.js', "updates["+currentVariant+"]="+qty+"", function(){ location.reload(); });
   }
  });
  
  $('.remove-item').on('click', function(e){
    e.preventDefault();
    var delArray = [];
    var groupKey = $(this).attr('data-productID');
    $('.cart-item[data-product="'+groupKey+'"]').each(function() {
      delArray.push($(this).attr('data-variantid'));
    });
    for (var i=delArray.length; i--;) {
      delArray[i] = 'updates[' + delArray[i]+ ']=0';
    }
    var updates = delArray.join('&'); 	

    jQuery.post('/cart/update.js', updates).done(function(cart){
      location.reload();
    }).fail(function(){
    });
  });
  $('.company-info').on('click', function(e){
    e.preventDefault();
    $(this).find('.company-account').slideToggle();
    $(this).find('i').toggleClass('bi-chevron-up');
  })
}); 

$(window).on('load', function(){
  setTimeout(function(){
    var h = Number($('.sku').outerHeight() + $('.title-row').outerHeight() + $('.price-cont').outerHeight() + $('.vendor ').outerHeight() + $('.related-items-cont').outerHeight());
    console.log(h);
    $('.product-form.theme-init').css('top','-'+(h-80)+'px');
  },500);
});

var myMenu = $('.navigation__tier-1').children('li.navigation__item--with-children');
myMenu.on({
  mouseenter: function() { $('.overlay').addClass( "is_hovered" ); },
  mouseleave: function() { $('.overlay').removeClass( "is_hovered" ); }
});

$('.navigation__tier-3 li.navigation__item').hover(function(){
    var parent = $(this).find('a').data('parent');
    var get_main =  $('.navigation__tier-1 li').find('[data-main="' + parent + '"]');
    $('.navigation__tier-1 li').removeClass('navigation__item--active');
   $(get_main).closest('li').addClass('navigation__item--active');
});

// if($("#NavigationTier2-1:hover").length != 0){
//             console.log("yes-in");
//         } else{
//             console.log("yes-out");
//         }

// var video_container = $('.video-container').eq(0);

// $(document).on('click',video_container,function(){
//   $('.altcolours')[0].click()
// });

var video_container = $('.video-container').eq(0);
$(video_container).click(function(){
   $('.altcolours')[0].click()
})

$(window).on('load', function(){
  $('.product-list .block-inner .product-block__title').matchHeight();
});

let interval = null;

// let domWorks = () => {
//      let d = document.querySelector('.template-product .price-container')
//      if(d){
//       $('.template-product .price-container .current-price').addClass('hide')
//       clearInterval(interval) // Change it via reference
//      }
// }

// interval = setInterval(domWorks, 100)
document.addEventListener('DOMContentLoaded', function () {
  const productCards = document.querySelectorAll('.product-list .product-block');

  productCards.forEach(function (card) {
    const brand = card.getAttribute('data-product-brand');
    const rawSku = card.getAttribute('data-product-sku');
    let formattedSku = '';

    if (rawSku) {
      if (brand && brand.toLowerCase() === 'deke') {
        const parts = rawSku.split(" ").filter(Boolean);
        formattedSku = parts.length > 1 ? parts[0] + '-' + parts[1] : parts[0] || '';
      } else {
        formattedSku = rawSku.split(" ")[0];
      }
    }

    const skuElement = card.querySelector('.sku__value');
    if (skuElement) {
      skuElement.innerHTML = '' + formattedSku;
    }
  });
});
document.addEventListener('variant:change', function(event) {
  var variant = event.detail.variant;
  if (variant) {
    document.querySelector('#selected-inseam').value = variant.option3; // assuming option2 is inseam
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const el = document.querySelector(
    '.clickyboxes.options--in-seam a[data-value="34"]'
  );
  if (el) {
    el.classList.remove("unavailable"); // optional
    el.click();
  }
});
